/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Dashboard_Extras_BookedInputs */

const en_admin_dashboard_extras_booked = /** @type {(inputs: Admin_Dashboard_Extras_BookedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extras Booked`)
};

const de_admin_dashboard_extras_booked = /** @type {(inputs: Admin_Dashboard_Extras_BookedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extras gebucht`)
};

const es_admin_dashboard_extras_booked = /** @type {(inputs: Admin_Dashboard_Extras_BookedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Con extras`)
};

const fr_admin_dashboard_extras_booked = /** @type {(inputs: Admin_Dashboard_Extras_BookedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extras réservés`)
};

const nl_admin_dashboard_extras_booked = /** @type {(inputs: Admin_Dashboard_Extras_BookedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extras gereserveerd`)
};

const pt_br2_admin_dashboard_extras_booked = /** @type {(inputs: Admin_Dashboard_Extras_BookedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Com extras`)
};

const ro_admin_dashboard_extras_booked = /** @type {(inputs: Admin_Dashboard_Extras_BookedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extra-uri Rezervate`)
};

/** @type {(inputs: Admin_Dashboard_Extras_BookedInputs) => LocalizedString} */
const it_admin_dashboard_extras_booked = en_admin_dashboard_extras_booked;

/** @type {(inputs: Admin_Dashboard_Extras_BookedInputs) => LocalizedString} */
const pl_admin_dashboard_extras_booked = en_admin_dashboard_extras_booked;

/** @type {(inputs: Admin_Dashboard_Extras_BookedInputs) => LocalizedString} */
const hu_admin_dashboard_extras_booked = en_admin_dashboard_extras_booked;

/**
* | output |
* | --- |
* | "Extras Booked" |
*
* @param {Admin_Dashboard_Extras_BookedInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_extras_booked = /** @type {((inputs?: Admin_Dashboard_Extras_BookedInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_Extras_BookedInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_extras_booked(inputs)
	if (locale === "de") return de_admin_dashboard_extras_booked(inputs)
	if (locale === "es") return es_admin_dashboard_extras_booked(inputs)
	if (locale === "fr") return fr_admin_dashboard_extras_booked(inputs)
	if (locale === "nl") return nl_admin_dashboard_extras_booked(inputs)
	if (locale === "it") return it_admin_dashboard_extras_booked(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_extras_booked(inputs)
	if (locale === "pl") return pl_admin_dashboard_extras_booked(inputs)
	if (locale === "hu") return hu_admin_dashboard_extras_booked(inputs)
	return ro_admin_dashboard_extras_booked(inputs)
});
export { admin_dashboard_extras_booked as "admin.dashboard.extras_booked" }